export default __webpack_public_path__ + "static/media/exam-record-ECV-mark.cdaa0f4f.svg";